import { render, staticRenderFns } from "./WithdrawalInfo.vue?vue&type=template&id=48ae6a9c&"
import script from "./WithdrawalInfo.vue?vue&type=script&lang=js&"
export * from "./WithdrawalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports